module.exports = __webpack_public_path__ + "static/media/github.6a6acc50.svg";